import axios from 'axios';

const actions = {
  async sendAxiosRequest({ dispatch }, vals) {
    let { method = 'get', url = '', data = {}, params = {}, requiresAuth = true } = vals
    try {
      if (requiresAuth) await dispatch('api/auth/checkAccessTokenForRequests', null, {root: true})
      const token = await dispatch('api/auth/getAccessToken', 'axios request', {root: true})
      let res = await axios({
        method,
        url,
        headers: token ? {
          Authorization: `Bearer ${token}`
        } : { },
        data,
        params
      })
      // console.log('success', data)
      return { success: res?.data || {} }
    } catch (error) {
      console.log('error', JSON.stringify(error))

      if (error.response?.data) {
        return {error: error.response.data}
      } else if (error.data) {
        return {error}
      } else {
        return false;
      }
    }
  },
}

export default {
	namespaced: true,
  actions
};
